<template>
  <div class="product">
    <img :src="src" />
  </div>
</template>

<script>
  export default {
    name: "SimplePhotoProduct",
    props:['src']
  };
</script>

<style lang="scss" scoped>
  .product img {
    object-fit: cover;
  }
</style>
